// extracted by mini-css-extract-plugin
module.exports = {"table":"DayPicker-table","calendarTd":"DayPicker-calendarTd","prevNextDays":"DayPicker-prevNextDays","weekDays":"DayPicker-weekDays"};